import React, { memo, useState } from 'react'
import styles from './ProductCardDialog.module.scss'
import { useNavigate } from 'react-router-dom'
import { SolarProduct } from '../../../model/solar-product/solar-product'
import ArhiveProductDialog from './ArhiveProductDialog'
import PauseProductDialog from './PauseProductDialog'
import { ApplicationRoutes } from '../../../routes'

type Props = {
    product: SolarProduct
    onClose: () => void
    triggerLoad? : () => void
}

const ProductCardDialog: React.FC<Props> = memo((props: Props) => {
    const { onClose, product, triggerLoad } = props

    const [pauseDialogOpen, setPauseDialogOpen] = useState(false)
    const [archiveDialogOpen, setArchiveDialogOpen] = useState(false)

    const navigate = useNavigate()

    const handleEditProduct = () => {
        navigate(`/${ApplicationRoutes.PROVIDER_BASE}/${ApplicationRoutes.EDIT_PRODUCT}${product.id}`)
    }

    const openPauseDialog = () => {
        setPauseDialogOpen(true)
    }

    const closePauseDialog = () => {
        setPauseDialogOpen(false)
        onClose()
    }

    const openArchiveDialog = () => {
        setArchiveDialogOpen(true)
    }

    const closeArchiveDialog = () => {
        setArchiveDialogOpen(false)
        onClose()
    }

    const handleArchiveProduct = () => {
        triggerLoad && triggerLoad()
        closeArchiveDialog()
    }

    const handlePauseProduct = () => {
        triggerLoad && triggerLoad()
        closePauseDialog()
    }

    return (
        <>
            <div className={styles.dialogBackdrop} onClick={onClose}/>
            <div className={styles.dialogContainer}>
                <button className={`standardButton ${styles.button}`} onClick={handleEditProduct}>
                    Edit Product
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.83158 14.0515C1.56663 14.1103 1.33853 14.0441 1.14728 13.8528C0.956048 13.6616 0.889812 13.4335 0.948576 13.1685L1.64568 9.82243L5.17768 13.3544L1.83158 14.0515ZM5.17768 13.3544L1.64568 9.82243L10.995 0.473075C11.2824 0.185686 11.6382 0.0419922 12.0623 0.0419922C12.4865 0.0419922 12.8422 0.185686 13.1296 0.473075L14.527 1.87049C14.8144 2.15788 14.9581 2.51364 14.9581 2.93778C14.9581 3.36192 14.8144 3.71769 14.527 4.00507L5.17768 13.3544ZM11.886 1.35126L3.3652 9.86407L5.13603 11.6349L13.6488 3.11407C13.6969 3.06599 13.721 3.00589 13.721 2.93378C13.721 2.86166 13.6969 2.80155 13.6488 2.75347L12.2466 1.35126C12.1986 1.30318 12.1385 1.27914 12.0663 1.27914C11.9942 1.27914 11.9341 1.30318 11.886 1.35126Z" fill="#2E3336" />
                    </svg>
                </button>
                <button className={`standardButton ${styles.button}`} onClick={openPauseDialog}>
                    {
                        product.isDeactivated ? 'Unpause ' : 'Pause '
                    }
                    Product Sales
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 14V0H14V14H8ZM0 14V0H6V14H0ZM10 12H12V2H10V12ZM2 12H4V2H2V12Z" fill="#1C1B1F" />
                    </svg>
                </button>
                <button className={`standardButton ${styles.button}`} onClick={openArchiveDialog}>
                    {
                        product.isArchived ? 'Unarchive ' : 'Archive '
                    }
                    Product
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 15L13 11L11.6 9.6L10 11.2V7H8V11.2L6.4 9.6L5 11L9 15ZM2 5V16H16V5H2ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V3.525C0 3.29167 0.0375 3.06667 0.1125 2.85C0.1875 2.63333 0.3 2.43333 0.45 2.25L1.7 0.725C1.88333 0.491667 2.1125 0.3125 2.3875 0.1875C2.6625 0.0625 2.95 0 3.25 0H14.75C15.05 0 15.3375 0.0625 15.6125 0.1875C15.8875 0.3125 16.1167 0.491667 16.3 0.725L17.55 2.25C17.7 2.43333 17.8125 2.63333 17.8875 2.85C17.9625 3.06667 18 3.29167 18 3.525V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2.4 3H15.6L14.75 2H3.25L2.4 3Z" fill="#1C1B1F" />
                    </svg>
                </button>
            </div>
            {
                pauseDialogOpen && <PauseProductDialog onCloseDialog={closePauseDialog} onProductPaused={handlePauseProduct} product={product} />
            }
            {
                archiveDialogOpen && <ArhiveProductDialog onCloseDialog={closeArchiveDialog} onProductArchived={handleArchiveProduct} product={product} />
            }
        </>

    )
})

export default ProductCardDialog